export const countMessagesSentByHourOfWeek = {
  analysisType: 'count',
  eventCollection: 'message.sent',
  groupBy: 'time.hour_of_week',
  key: 'countMessagesSentByHourOfWeek',
}
